module.exports = __webpack_public_path__ + "static/media/CU.2b3809db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CU.svg
// module id = 233
// module chunks = 0